import { takeLatest } from "redux-saga/effects";
import { ActionTypes } from "../constants";

import authnzConfirmRegistrationWorker from "./authnz/confirmRegistration";
import authnzForgotPasswordWorker from "./authnz/forgotPassword";
import authnzResendCodeWorker from "./authnz/resendCode";
import authnzSetNewPasswordWorker from "./authnz/setNewPassword";
import authnzUpdatePasswordWorker from "./authnz/updatePassword";
import authnzUserLoginWorker from "./authnz/login";
import authnzUserLogoutWorker from "./authnz/logout";
import authnzUserSignUpWorker from "./authnz/signup";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzWatcher(): Generator<any, any, any> {
  yield takeLatest(ActionTypes.AUTHNZ_CONFIRM_REGISTRATION, authnzConfirmRegistrationWorker);
  yield takeLatest(ActionTypes.AUTHNZ_FORGOT_PASSWORD, authnzForgotPasswordWorker);
  yield takeLatest(ActionTypes.AUTHNZ_RESEND_CODE, authnzResendCodeWorker);
  yield takeLatest(ActionTypes.AUTHNZ_SET_NEW_PASSWORD_REQUIRED, authnzSetNewPasswordWorker);
  yield takeLatest(ActionTypes.AUTHNZ_UPDATE_PASSWORD, authnzUpdatePasswordWorker);
  yield takeLatest(ActionTypes.AUTHNZ_USER_LOG_OUT, authnzUserLogoutWorker);
  yield takeLatest(ActionTypes.AUTHNZ_USER_SIGN_IN, authnzUserLoginWorker);
  yield takeLatest(ActionTypes.AUTHNZ_USER_SIGN_UP, authnzUserSignUpWorker);
}
